export default [
	{
		path: '/index',
		name: 'index',
		component: () => import('@/views/index'),
		meta: { title: "阳泉高新技术产业开发区双创公共服务平台", requireLogin: false }
	},
    // {
    //     path: '/indexNew',
    //     name: 'indexNew',
    //     component: () => import('@/views/home/index'),
    //     meta: { title: "阳泉高新技术产业开发区双创公共服务平台", requireLogin: false }
    // },
    {
        path: '/projectReview',
        name: 'projectReview',
        component: () => import('@/views/projectReview'),
        meta: { title: "信息化项目评审", requireLogin: false }
    },
	{
        path: '/projectReviewDetail',
        name: 'projectReviewDetail',
        component: () => import('@/views/projectReviewDetail'),
        meta: { title: "信息化项目评审详情", requireLogin: false }
    },
	{
		path: '/notice',
		name: 'notice',
		component: () => import('@/views/notice'),
		meta: { title: "政策公告", requireLogin: false }
	},
	{
		path: '/EnterpriseSealService',
		name: 'EnterpriseSealService',
		component: () => import('@/views/EnterpriseSealServiceUNlogin'),
		meta: {title: "企业刻章服务", requireLogin: false}
	},
	{
		path: '/EnterpriseSealService/Add',
		name: 'EnterpriseSealServiceAdd',
		component: () => import('@/views/EnterpriseSealServiceUNlogin/components/AddOrEditModal'),
		meta: {title: "新办企业刻章服务", requireLogin: false}
	},
	{
		path: '/materializePolicy',
		name: 'materializePolicy',
		component: () => import('@/views/materializePolicyUNlogin'),
		meta: {title: "企业刻章服务", requireLogin: false}
	},
	{
		path: '/materializePolicy/Add',
		name: 'materializePolicyAdd',
		component: () => import('@/views/materializePolicyUNlogin/components/AddOrEditModal'),
		meta: {title: "新办企业刻章服务", requireLogin: false}
	},
	{
		path: '/materializePolicy/Detail',
		name: 'materializePolicyDetail',
		component: () => import('@/views/materializePolicyUNlogin/components/DetailModal'),
		meta: {title: "新办企业刻章服务详情", requireLogin: false}
	},
	{
		path: '/noticeDetail',
		name: 'noticeDetail',
		component: () => import('@/views/noticeDetail'),
		meta: { title: "政策公告详情", requireLogin: false }
	},
	{
		path: '/xcIndex',
		name: 'xcIndex',
		component: () => import('@/views/webNotice/xcIndex'),
		meta: { title: "专栏列表", requireLogin: false }
	},
	{
		path: '/webNotice',
		name: 'webNotice',
		component: () => import('@/views/webNotice/notice'),
		meta: { title: "专栏列表", requireLogin: false }
	},
	{
		path: '/webNoticeDetail',
		name: 'webNoticeDetail',
		component: () => import('@/views/webNotice/noticeDetail'),
		meta: { title: "专栏详情", requireLogin: false }
	},
	{
		path: '/highEnterpriseSerch',
		name: 'highEnterpriseSerch',
		component: () => import('@/views/webNotice/highEnterpriseSerch'),
		meta: { title: "高企查询", requireLogin: false }
	},
	{
		path: '/highEnterpriseDetail',
		name: 'highEnterpriseDetail',
		component: () => import('@/views/webNotice/highcommon/highEnterpriseDetail'),
		meta: { title: "高企详情", requireLogin: false }
	},
	{
		path: '/webHighEnterpriseEvaluation',
		name: 'webHighEnterpriseEvaluation',
		component: () => import('@/views/webHighEnterpriseEvaluation'),
		meta: { title: "高企助手", requireLogin: false }
	},
	{
		path: '/webHighEnterpriseEvaluation/test',
		name: 'webHighEnterpriseEvaluation_test',
		component: () => import('@/views/webHighEnterpriseEvaluation/page/components'),
		meta: { title: "高企助手测评", requireLogin: false }
	},

	{
		path: '/webHighEnterpriseEvaluation/list',
		name: 'webHighEnterpriseEvaluation_list',
		component: () => import('@/views/webHighEnterpriseEvaluation/user/list'),
		meta: { title: "高企助手测评列表", requireLogin: false }
	},

	{
		path: '/webHighEnterpriseEvaluation/detail',
		name: 'webHighEnterpriseEvaluation_detail',
		component: () => import('@/views/webHighEnterpriseEvaluation/user/detail'),
		meta: { title: "高企助手测评详情", requireLogin: false }
	},
	{
		path: '/webHighEnterpriseEvaluation/LoginWx',
		name: 'webHighEnterpriseEvaluation_LoginWx',
		component: () => import('@/views/webHighEnterpriseEvaluation/loginWx'),
		meta: { title: "高企助手登录", requireLogin: false }
	},
	{
		path: '/webHighEnterpriseEvaluation/fixPass',
		name: 'webHighEnterpriseEvaluation_fixPass',
		component: () => import('@/views/webHighEnterpriseEvaluation/fixPass'),
		meta: { title: "高企助手修改密码", requireLogin: false }
	},
	{
		path: '/webHighEnterpriseEvaluation/Login',
		name: 'webHighEnterpriseEvaluation_Login',
		component: () => import('@/views/webHighEnterpriseEvaluation/login'),
		meta: { title: "高企助手登录", requireLogin: false }
	},
	{
		path: '/webHighEnterpriseEvaluation/Register',
		name: 'webHighEnterpriseEvaluation_Register',
		component: () => import('@/views/webHighEnterpriseEvaluation/register'),
		meta: { title: "高企助手注册", requireLogin: false }
	},

	{
		path: '/corpBase',
		name: 'corpBase',
		component: () => import('@/views/corpBase'),
		meta: { title: "基地", requireLogin: false }
	},
    {
        path: '/integral/pyku',
        name: 'integral_pyku',
        component: () => import('@/views/integral/components/cont/pyku'),
        meta: { title: "企业培育库", requireLogin: false },
        redirect: '/integral/pyku/index',
        children: [
            {
                path: '/integral/pyku/index',
                name: 'integral_pyku_index',
                component: () => import('@/views/integral/components/cont/pykus/index'),
                meta: { title: "企业培育库", requireLogin: false },
            }
        ]
    },
    {
        path: '/integral',
        name: 'integral',
        component: () => import('@/views/integral'),
        meta: { title: "积分制首页", requireLogin: false },
        redirect: '/integral/index',
        children: [
            {
                path: '/integral/index',
                name: 'integral_index',
                component: () => import('@/views/integral/components/index'),
                meta: { title: "积分制首页", requireLogin: false },
            }
        ]
    }
]
